var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"anti-induled__payment"},[(_vm.antiInduledType || _vm.antiInduledType === 0)?_c('AntiInduled',{attrs:{"branch":"payment","type":_vm.antiInduledType,"customer":_vm.customer,"isClient":true},on:{"close":_vm.close,"changeData":_vm.changeData,"submit":_vm.submit,"confirm":_vm.confirm,"cancel":_vm.cancel}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }